import styled from 'styled-components';

const StyledInputItem = styled.div`
  position: relative;
  width: 100%;
  &.with-icon {
    > label {
      display: flex;
      align-items: center;
    }
  }
  &.file-upload {
    text-align: center;
    img {
      cursor: pointer;
    }
    .file-name {
      display: block;
      max-width: 150px;
      font-size: 14px;
      font-weight: bold;
    }
  }
  & > label {
    display: ${props => props.alignStart ? 'flex' : 'block'};
    align-items: ${props => props.alignStart ? 'center' : ''};
    width: 100%;
    margin-bottom: 10px;
    text-align: ${props => props.alignStart ? 'start' : 'center'};
    font-size: 17px;
    line-height: 20px;
    font-weight: bold;
    &.error {
      position: absolute;
      top: 100%;
      inset-inline-start: 10px;
    }
    img {
      margin-inline-end: 10px;
      cursor: pointer;
    }
  }
  .form-control {
    height: 40px;
    border: ${props => props.withBorder ? '1px solid rgba(110, 116, 255, 0.4)' : '0'};
    font-size: 14px;
    line-height: 22px;
    color: ${props => props.theme.text};
    box-shadow: ${props => props.withBorder ? 'none' : '0 3px 10px rgba(89, 102, 137, 0.12)'};
    border-radius: 50px;
    &.error {
      border: 1px solid red !important;
    }
  }
  .error {
    .DayPickerInput {
      color: #000;
      &::after {
        border-color: red;
      }
      input {
        border-color: red;
      }
    }
  }
`;

export default function InputGroup({labelText, labelFor, labelContent, labelClassName, errorText, withBorder, classes, alignStart, children}) {
    return (
        <StyledInputItem className={`${classes || ''} input-item`} withBorder={withBorder} alignStart={alignStart}>
            <label htmlFor={labelFor} className={labelClassName}>{labelContent || labelText}</label>
            {children}
            {errorText && <label className={'error'}>{errorText}</label>}
        </StyledInputItem>
    );
}